import { createTheme, colors, lighten } from '@mui/material';
import shadows from './shadows';
import typography from './typography';
import BreakPoints from './breakPoints';

const theme = createTheme({
    breakpoints: {
        values: BreakPoints,
    },
    palette: {
        primary: {
            main: '#0f0f68',
            50: '#f2f3ff',
            100: '#dfe1ff',
            200: '#bcc0ff',
            300: '#8f94ff',
            400: '#5f68f0',
            500: '#343cc8',
            600: '#212a9c',
            700: '#171f80',
            800: '#101664',
            900: '#0a0f4a',
            950: '#04082f',
        },
        secondary: {
            main: '#d4af36', // Default coral
            50: '#faf9ec',
            100: '#f4f0ce',
            200: '#ebdf9d',
            300: '#dfc864',
            500: '#c49b2e',
            600: '#aa7a24',
            700: '#88591f',
            800: '#724921',
            900: '#623e21',
            950: '#382010',
        },
        tertiary: {
            main: '#ebe2ca', // Default coral
            10: '#fcfbf7',
            20: '#f9f7f0',
            30: '#f7f2e8',
            40: '#f4eee1',
            50: '#f1ead9',
            60: '#efe6d1',
            70: '#ebe2ca',
            90: '#e6d9bb',
            100: '#e4d4b3',
        },
        gray: {
            main: '#454545', // Default coral
            50: '#f6f6f6',
            100: '#e7e7e7',
            200: '#d1d1d1',
            300: '#b0b0b0',
            400: '#888888',
            500: '#6d6d6d',
            600: '#5d5d5d',
            700: '#4f4f4f',
            900: '#333333',
            950: '#262626',
        },
    },
    shadows,
    typography,
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
    },
});

export default theme;
